angular.module('concept-map')
    .directive('svgMap', ['$compile','$window', function($compile, $window) {

        return {
            restrict: 'A',
            templateUrl: '/resources/images/concept-map/ConceptMapBg.svg',
            link: function (scope, element, attrs) {

                // select all lesson group nodes
                // dynamically insert a directive here to turn it into a lesson-group directive
                // so that lesson group dots can be interactive
                // example:
                // <g id="P97" lesson-group class='lesson-group' state='lesson-group' ...

                var lessonGroups = element[0].querySelectorAll('#LessonGroup > g');
                angular.forEach(lessonGroups, function (path, key) {
                    var lessonGroupElement = angular.element(path);
                    lessonGroupElement.attr("lesson-group", '');
                    lessonGroupElement.attr("class", 'lesson-group');
                    lessonGroupElement.attr('data', "lessonGroups['" + lessonGroupElement[0].id  + "']");
                    $compile(lessonGroupElement)(scope);
                });
            }
        };
    }]);
